// дескриптор для менеджеров админов
export const Manager = {
    // идентификатор дескриптора
    id: 'manager',
    title: 'manager',
    EditFbsFbo:true,
    // в данном случае описываются доступные вкладки
    items: [{id:'newClients', title: 'Новые клиенты', icon: 'newClients'}, 
        {id:'myClients', title: 'Мои клиенты', icon: 'myClients'},
        {id:'pickProducts', title: 'Забор товара', icon: 'pickProducts'},
        {id:'moveProducts', title: 'Движение товара', icon: 'moveProducts'},
        {id:'saveProducts', title: 'Адресное хранение', icon: 'saveProducts'},
        {id:'transfer', title: 'Отгрузка', icon: 'transfer'},
        // {id:'DealTable', title: 'Сделка', icon: 'pickProducts'}
    ],
  };